import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import logo from "../image/hifi.png";
import registerImg from "../image/Registerimage.png";
import Footer from "./footer";
import { Link, useNavigate } from "react-router-dom";
import { ethers } from "ethers";
import { useLocation } from "react-router-dom";
import { tokenAddress, mainContractAddress, BSC_TESTNET_CHAIN_ID, tokenABI, mainContractABI, rpcUrls, blockExplorerUrls } from "../components/constant.js";
const Register = () => {
  const navigate = useNavigate();


  const [isDAppBrowser, setIsDAppBrowser] = useState(false);
  const [walletAddress, setAddress] = useState('');
  // const tokenAddress = "0x662d5C621B05207BECed12F5460b2EF4122f33fd";
  // const mainContractAddress = "0x240787362C8edBE7E4E5ECFAD4fBc3B0Fb963ffa";
  const [referrerAddress, setRefferalAddress] = useState('');
  const [urlSponsor, setUrlSponsor] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [tokenBalance, setTokenBalance] = useState(0);

  const location = useLocation();
  const query = new URLSearchParams(location.search);

 
  // const BSC_TESTNET_CHAIN_ID = '0x61';
  // const tokenABI = [{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"},{"internalType":"uint8","name":"_decimals","type":"uint8"},{"internalType":"uint256","name":"_initialSupply","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"tokenOwner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]
  // const mainContractABI = [{"inputs":[{"internalType":"address","name":"_usdt","type":"address"},{"internalType":"address","name":"_reserve1","type":"address"},{"internalType":"address","name":"_reserve2","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"DirectIncome","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"level","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"LevelIncome","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"oldFee","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newFee","type":"uint256"}],"name":"RegistrationFeeUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"address","name":"reserve","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"string","name":"reason","type":"string"}],"name":"ReserveTransfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"reserveType","type":"uint256"},{"indexed":false,"internalType":"address","name":"oldWallet","type":"address"},{"indexed":false,"internalType":"address","name":"newWallet","type":"address"}],"name":"ReserveWalletUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"oldFee","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newFee","type":"uint256"}],"name":"UpgradeFeeUpdated","type":"event"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"levelPercent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"regFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"sponsor","type":"address"}],"name":"register","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"reserve1","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"reserve2","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"newFee","type":"uint256"}],"name":"setRegistrationFee","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"reserveType","type":"uint256"},{"internalType":"address","name":"newWallet","type":"address"}],"name":"setReserveWallet","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newFee","type":"uint256"}],"name":"setUpgradeFee","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"upgrade","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"upgradeFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"usdt","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"users","outputs":[{"internalType":"bool","name":"registered","type":"bool"},{"internalType":"bool","name":"upgraded","type":"bool"},{"internalType":"address","name":"sponsor","type":"address"},{"internalType":"uint256","name":"directCount","type":"uint256"}],"stateMutability":"view","type":"function"}]


  const connectWallet = async () => {
    if (typeof window.ethereum === "undefined") {
      return alert("MetaMask not installed");
    }
    try {
      const provider = new ethers.BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();
      const address = await signer.getAddress();
      setAddress(address);
      setIsDAppBrowser(true);
      const tokenContract = new ethers.Contract(tokenAddress, tokenABI, signer);
      let tokenBalance = await tokenContract.balanceOf(address);
      // const bnbBalance = await provider.getBalance(address)
      setTokenBalance(ethers.formatUnits(tokenBalance, 18))
    } catch (err) {
      console.error("Wallet connection failed:", err);
    }
  };

  const approveAndRegister = async () => {
    try {
      console.log("Sponsor:", referrerAddress);
      const currentChainId = await window.ethereum.request({ method: 'eth_chainId' });
      if (currentChainId !== BSC_TESTNET_CHAIN_ID) {
        try {
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: BSC_TESTNET_CHAIN_ID }],
          });
        } catch (switchError) {
          if (switchError.code === 4902) {
            // Chain not added, try to add it
            await window.ethereum.request({
              method: 'wallet_addEthereumChain',
              params: [{
                chainId: BSC_TESTNET_CHAIN_ID,
                chainName: 'Binance Smart Chain Testnet',
                nativeCurrency: {
                  name: 'BNB',
                  symbol: 'BNB',
                  decimals: 18,
                },
                rpcUrls: [rpcUrls],
                blockExplorerUrls: [blockExplorerUrls],
              }],
            });
          } else {
            console.error('Failed to switch network', switchError);
            return;
          }
        }
      }

      console.log('loader start')
      setIsLoading(true);
      setStatus("Waiting for approval...");
      const provider = new ethers.BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();
      console.log(' at lint 41', tokenAddress)
      // 1. Approve tokens
      const tokenContract = new ethers.Contract(tokenAddress, tokenABI, signer);
      const decimals = await tokenContract.decimals();


      const amount = '30000000000000000000';//ethers.parseUnits("20", "18");
      console.log(amount, ' decimal is here ', decimals)
      const approveTx = await tokenContract.approve(mainContractAddress, amount);
      setStatus("Approving " + amount + " tokens...");
      await approveTx.wait();
      setStatus("Approval successful!");

      // 2. Call registerOther(user, referrer)
      const mainContract = new ethers.Contract(mainContractAddress, mainContractABI, signer);
      console.log("USDT:", tokenAddress);
      console.log("Contract:", mainContractAddress);
      console.log("Fee:", await mainContract.regFee());
      // console.log("Allowance:", await tokenContract.allowance(myWallet, mainContractAddress));
      // ✅ Decide sponsor here (INPUT or URL fallback)
      const sponsorToUse = referrerAddress || urlSponsor;

      if (!sponsorToUse) {
        alert("Please paste referral address");
        setIsLoading(false);
        return;
      }

      console.log("Sponsor used:", sponsorToUse);

      const registerTx = await mainContract.register(sponsorToUse);

      // const registerTx = await mainContract.register(referrerAddress); 
      // const registerTx = await mainContract.registerOther('0xd6977aD7D3cEaE67D0901622d130B2EaD4a7b574', referrerAddress); //
      setStatus("Registering user...");
      await registerTx.wait();
      alert('Congratutlations Registration Complete')
      setStatus("✅ Registration complete!");
      setIsLoading(false);

    } catch (err) {
      console.error(err);
      setStatus("❌ Error: " + (err?.message || "Something went wrong"));
      // setIsLoading(false);

    }
  };

  // useEffect(() => {
  //   connectWallet()
  //   const queryParams = new URLSearchParams(window.location.search);
  //   const id = queryParams.get("sponser_id");
  //    console.log(' id is. ' , id)
  //   if(id === null){
  //     console.log('setting constant sponser')
  //     setRefferalAddress("0x8b06dd41428ac2C08707da82c87c4f261416Cec3")
  //   } else{
  //     console.log('setting sponser from url')
  //     setRefferalAddress(id);
  //   }

  // }, []);
  useEffect(() => {
    connectWallet();
     let sponserId = query.get("sponser_id");
    if(sponserId != ''){
      console.log('now we set sponsorId ' ,sponserId )
      setRefferalAddress(sponserId)
    }
    console.log('sponserId ' ,sponserId) 
  }, []);



  return (

    <>
      <div className="container-fluid px-3 px-md-5" style={{ backgroundColor: "#0d0e13", minHeight: "100vh" }} >

        <div className="container-fluid p-3">
          <nav
            className="custom-navbar d-flex align-items-center justify-content-between"
          >
            {/* <!-- Logo --> */}
            <div className="logo">
              <img src={logo} alt="Logo" />
            </div>

            {/* <!-- Right Menu --> */}
            <div className="d-flex align-items-center">
              <button className="connect-wallet-btn" onClick={() => navigate(-1)}>Back</button>
            </div>
          </nav>
        </div>
        <section
          className="register-page d-flex align-items-center justify-content-center"
        >
          <div className="register-box">
            <h2 className="register-title">Register to Get Started</h2>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="text-white">Referral Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Please enter referral Address"
                  style={{
                    backgroundColor: "#171a17ff",
                    border: "none",
                    color: "#fff",
                    padding: "12px",
                    borderRadius: "6px",
                  }}
                  value={referrerAddress}
                  onChange={(e) => { setRefferalAddress(e.target.value) }}
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label className="text-white">Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Please enter address"
                  style={{
                    backgroundColor: "#171a17ff",
                    border: "none",
                    color: "#fff",
                    padding: "12px",
                    borderRadius: "6px",
                  }}
                  value={walletAddress}
                />
                <p className="text-white pt-2"><b className="text-end">USDT : ${tokenBalance}</b> &nbsp;&nbsp;&nbsp;&nbsp;
                </p>

              </Form.Group>
              {isDAppBrowser ? (
                <>
                  {isLoading ? (
                    <div style={{ marginTop: "20px" }}>
                      <p style={{ color: "white" }}>{status}</p>
                      <div className="spinner"></div> {/* Optional: spinner design */}
                    </div>
                  ) : (
                    <button style={{
                      backgroundColor: "#a88756",
                      border: "none",
                      color: "#eee",
                      padding: "12px",
                      borderRadius: "6px",
                      textAlign: "center",
                      textDecoration: "none",
                      display: "inline-block",
                      fontWeight: 600,
                    }}
                      type="button" onClick={() => { approveAndRegister() }} disabled={isLoading}>  Approve & Register </button>
                  )}

                  {/* <Button 
                        className="btn w-100 fw-semibold"
                        style={{
                          backgroundColor: "#A1EF55",
                          border: "none",
                          color: "#000",
                          padding: "12px",
                          borderRadius: "6px",
                          textAlign: "center",
                          textDecoration: "none",
                          display: "inline-block",
                        }}
                        onClick={() => {approveAndRegister()}}
                      >
                        Submit
                      </Button> */}
                  {/* <p style={{ marginTop: "10px", color: "#555" }}>{status}</p> */}
                </>
              ) : (
                <p style={{ color: "red" }}>❌ DApp browser not found. Please install Trust , SafePal or MetaMask.</p>
              )}


              <p className="mt-3 text-white text-center small">
                Already Registered?{" "}
                <Link
                  to="/connect_wallet"
                  className="register-login"
                  style={{ cursor: "pointer", textDecoration: "none" }}
                >
                  Connect Wallet{" "}
                </Link>
                to Continue
              </p>
            </Form>

          </div>
        </section>
        <footer className="site-footer">
          <div className="container text-center">
            {/* <!-- Logo --> */}
            <div className="footer-logo mb-3">
              <img src={logo} alt="hifi Logo" />
            </div>

            {/* <!-- Divider --> */}
            <div className="footer-divider"></div>

            {/* <!-- Text --> */}
            <div className="footer-text">
              © 2025 Hifi Internationals | All Rights Reserved.
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Register;